<ng-template #customActionableContent let-data>
	<p cdsActionableTitle>{{data.title}}</p>
	<p cdsActionableSubtitle>{{data.myData.subtitle}}</p>
</ng-template>

<cds-actionable-notification
	*ngIf="showNotification"
	[notificationObj]="{
			type: notificationType,
			template: customActionableContent,
			title: notificationTitle,
			myData: {
				subtitle: notificationSubtitle
			},
			showClose: true
		}"
	(close)="showNotification = false"
></cds-actionable-notification>
